module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/loans@2x-6ea92867100b24a24beac9312ec46c7e.png";